import axios from 'axios'
import { PaperTypeModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_ALL_PAPER_TYPE = `${API_URL}/article/list_all_paper_type`
export const GET_ALL_MAJOR = `${API_URL}/article/list_all_major`
export const GET_ALL_DEGREE_NAME = `${API_URL}/article/list_all_degree_name`
export const GET_ALL_STAFF_TYPE = `${API_URL}/article/list_all_staff_type`
export const SAVE_ARTICLE = `${API_URL}/article/save_article`
export const UPLOAD_FILE_URL = `${API_URL}/upload_file`
export const GET_ALL_PERSONAL_PUBLICATION = `${API_URL}/article/list_all_personal_article`
export const GET_FULL_PERSONAL_PUBLICATION = `${API_URL}/article/list_full_personal_article`
export const UPDATE_PUBLICATION_STATUS = `${API_URL}/article/update_publication_status`
export const LIST_RECENT_ARTICLE = `${API_URL}/article/list_all_recent_article`
export const LIST_ALL_GOOD_PRACTICE = `${API_URL}/knowledge/list_all_good_practice`
export const GET_GOOD_PRACTICE = `${API_URL}/knowledge/load_item_by_id`
export const GET_KNOWLEDGE_BY_MENU_ID = `${API_URL}/knowledge/list_all_visible_knowledge_by_menu_id`

export function getPDFURL(pdf_file_name:string) {
    return `${API_URL}/upload_file/` + pdf_file_name
}

export function getAllPaperTypes() {
    return axios.post(GET_ALL_PAPER_TYPE, {})
}

export function getAllMajors() {
    return axios.post(GET_ALL_MAJOR, {})
}

export function getAllGoodPractices() {
    return axios.post(LIST_ALL_GOOD_PRACTICE, {})
}

export function getSingleGoodPractice(item_id:string | null) {
    return axios.post(GET_GOOD_PRACTICE, {item_id})
}

export function getAllVisibleKnowledgeByMenuID(knowledge_menu_id:string | null) {
    return axios.post(GET_KNOWLEDGE_BY_MENU_ID, {knowledge_menu_id})
}

export function getAllDegreeNames() {
    return axios.post(GET_ALL_DEGREE_NAME, {})
}

export function getAllStaffType() {
    return axios.post(GET_ALL_STAFF_TYPE, {})
}

export function listPersonalPublication(student_id:string) {
    return axios.post(GET_ALL_PERSONAL_PUBLICATION, {student_id})
}

export function loadFullPersonalPublication(publication_id:string | null) {
    return axios.post(GET_FULL_PERSONAL_PUBLICATION, {publication_id})
}

export function updatePublicationStatus(article_id:string | null, status:string, student_id: string){
    return axios.post(UPDATE_PUBLICATION_STATUS, {article_id, status, student_id})
}

export function listRecentArticle(personType: string, major_id:string, degree_id:string, search:string, start_item:number, offset:number) {
    console.log("personType: "+personType)
    return axios.post(LIST_RECENT_ARTICLE, {personType, major_id, degree_id, search, start_item, offset})
}

export function addArticle(title_th: string, title_en: string, description: string, reference: string, 
    contributor: string, advisor: string, abstract_en: string, abstract_th: string,
    public_year: string, degree_level: string, academic_year: string, keyword: string,
    major_id: string, degreename_id: string, journal_name:string, conference_name:string,
    pdf_file: string, type_id: string, status: string, student_id: number | undefined,
    opt: string, article_id: string
    ){

        //alert(degreename_id)
        return axios.post(SAVE_ARTICLE, {
            title_th, title_en, description, reference, 
            contributor, advisor, abstract_en, abstract_th,
            public_year, degree_level, academic_year, keyword,
            major_id, degreename_id, journal_name, conference_name,
            pdf_file, type_id, status, student_id, opt, article_id
        })
}
  